module.exports = __webpack_public_path__ + "static/PP-Logo-Full-Color-TM-94b1a2d250d24b6d4e4bfedd342bcbb6.svg";